import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isShowModal,
    onClose: $setup.close,
    classes: "image-cropper-modal"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "modal-title" }, "Crop Image", -1)),
        _createElementVNode("div", { class: "actions" }, [
          _createElementVNode("button", {
            class: "button default primary",
            onClick: $setup.close
          }, "Cancel"),
          _createElementVNode("button", {
            class: "button default primary",
            onClick: $setup.clear
          }, "Clear selection"),
          _createElementVNode("button", {
            class: "button default primary",
            onClick: $setup.reset
          }, "Reset selection"),
          _createElementVNode("button", {
            class: "button default primary",
            onClick: $setup.onCropImage
          }, "Crop Image")
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode($setup["VuePictureCropper"], {
            boxStyle: $setup.boxStyle,
            img: $setup.props.image,
            options: $setup.options
          }, null, 8, ["img", "options"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}